import React from 'react';
import { Link } from 'react-router-dom';
import './home.css';

const HomePage = () => {
  return (
    <div>
      <div className="home-link">
        <Link to="/eagle-tracker" className="text-link">
          Fan Tent Eagle Interrupter
        </Link>
      </div>

      <div className="home-link">
        <Link to="/score-bug" className="text-link">
          Fant Tent Horizontal Eagle Score Bug
        </Link>
      </div>

      <div className="home-link">
        <Link to="/fan-tent" className="text-link">
          Fant Tent TV Screen
        </Link>
      </div>

      <div className="home-link">
        <Link to="/the-grove" className="text-link">
          The Grove
        </Link>
      </div>

      <div className="home-link">
        <Link to="/hospitality-17" className="text-link">
          17 Hospitality Tent (Landscape)
        </Link>
      </div>

      <div className="home-link">
        <Link to="/hospitality-17-portrait" className="text-link">
          17 Hospitality Tent (Portrait)
        </Link>
      </div>

      <div className="home-link">
        <Link to="/hospitality-18" className="text-link">
          18 Hospitality Tent
        </Link>
      </div>

      <div className="home-link">
        <Link to="/ms-offices" className="text-link">
          Morgan Stanley Offices
        </Link>
      </div>

      <div className="home-link">
        <Link to="/test-page" className="text-link">
          Test Page
        </Link>
      </div>
    </div>
  );
};

export default HomePage;
